module.exports = __webpack_public_path__ + "img/tishi.9088ddf5.png";